import React, { useState, useEffect } from 'react';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import format from 'date-fns/format';
import { makeStyles } from '@material-ui/core/styles';
import { notificationCenterWidth, RightSideBarWidth } from '../../../styleVariables';
import useMountEffect from '../../../mountEffect';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import * as logger from "../../../logger";
import AddRoundedIcon from '@material-ui/icons/AddRounded';

import { connect } from 'react-redux';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import {
  updateChatView, toggleChatSupport
} from "../../../store/actions/userActionCreators";
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import { freshChat } from '../../../configs/configs';
import FreshChat from 'react-freshchat';
import MobileStepper from '@material-ui/core/MobileStepper';
import { DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { biltyContinueClick } from '../../../store/actions/tripActionCreator';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ExcelIcon, PdfIconWhite } from '../../../components/icons';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Box } from '@material-ui/core';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import moment from 'moment';
import { getDateInStringDDMMMYYYY,isFunction } from '../../../utils/utils';
import JourneyDriverSelect from '../Driver/JourneyDriverSelect';
import { updateJourney } from '../../../store/actions/tripActionCreator';
import AddEditLoadSideBar from '../Trip/AddEditLoadSideBar';
import JourneyVehicleSelect from '../Driver/JourneyVehicleSelect';
import DeleteTripJourney from '../Trip/DeleteTripJourney';
import { SteeringWheel } from '../../../components/icons';
const useStyles = makeStyles(theme => ({
  transactionDetailsDrawer: {
    width: 475,
    maxWidth: 475,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  modal: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  backdrop: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    }
  },
  container: {
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: 1,
    flexGrow: 1
  },
  sideBarDialogContentV1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: 30,
    paddingLeft:30,
    paddingRight:30,
    paddingBottom: 20,
    backgroundColor:'#f6f6f8'
  },
  sideBarDialogContentV2: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 30,
    paddingLeft:30,
    paddingRight:30,
    paddingBottom: 20,
    backgroundColor:'#f6f6f8'
  },
  divTitle: {
    display: 'flex',
    alignItems: 'center',
    color: "#0b1323",
    fontSize:18,
    marginBottom:4,
    lineHeight:1.33,
    letterSpacing:'normal',
    textTransform:'capitalize'
  },
  divSecTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize:12,
    color:"rgba(11, 19, 35, 0.75)",
    marginBottom:8
  },
  titleDiv:{
    display:'flex',
    flexDirection:'column'
  },
  icon:{
    fontSize:16
  },
  text:{
    fontSize:14,
    marginLeft:8
  },
  customer:{
    fontSize:16,
    fontWeight:600,
  },
  edit:{
    color:'#03c',
    padding:'6px 16px',
    cursor:'pointer',
    fontSize:14,
    borderRadius: 4,
    border: "solid 1px #ebebeb",
  },
  delete:{
    color:'#d71e1d',
    padding:'6px 16px',
    cursor:'pointer',
    fontSize:14,
    borderRadius: 4,
    border: "solid 1px #ebebeb",
  },
  box:{
    borderRadius:8,
    backgroundColor:'#fff'
  },
  sep:{
    color:'#c4c4c4',
    margin:'0 8px',
    fontSize:6
  },
  route:{
    fontSize:12
  },
  date:{
    fontSize:12,
    color:'#6a6a6a'
  }
}));

const EditLoadDetailsSideBar = ({
  rightSideBarOpen,
  toggleRightSideBar,
  user,
  data,
  children,
  sideBarName,
  sideBarTitle,
  sideBarSecondaryTitle,
  handleSubmit,
  dispatchChatView,
  onEdit,
  onDelete,
  cStyle,
  //journey,
  fetchJourney,
  dispatchUpdateTrip
}) => {
  let history = useHistory();
  let journey = user.singleTripData ? user.singleTripData : {};
  let driver = journey.driver?journey.driver:null;
  let vehicle = journey.vehicle?journey.vehicle:null;
  let trips = journey.trips?journey.trips:null
  const [validate, setValidate] = useState(false);
  const [updateChatView, setChatView] = useState(false);
  const [progress, setProgress] = useState(25);
  const [checkDataPopulated, setCheckDataPopulated] = useState(false);
  const [checkStatusAllTrue, setCheckStatusAllTrue] = useState(false);
  const [driverNameModalOpen, setDriverNameModalOpen] = React.useState(false);
  const [vehicleSelectModalOpen, setVehicleSelectModalOpen] = React.useState(false);
  const [addEditTripSideBarOpen, setAddEditTripSideBarOpen] = useState(false);
  const [selectedTrip,setSelectedTrip] =  useState(false);
  const [deleteTripOpen, setDeleteTripOpen] = useState(false);
  const onTripDeleteSucees = () => {
    setDeleteTripOpen(false);
    handleClose()
    if(trips && trips.length>1){
      if (isFunction(fetchJourney) && journey.id) {
        fetchJourney(journey.id)
      }
    }else{
      history.push({
        pathname: '/trips',
        state: {
          id: 7,
          pageTitle: 'Trips'
        }
      });
    }
  }
  const onTripDeleteNo = () => {
    setDeleteTripOpen(false);
    if (isFunction(fetchJourney) && journey.id) {
      fetchJourney(journey.id)
    }
  }
  const handleDriverSelectClose = () => {
    setDriverNameModalOpen(false);
    if (isFunction(fetchJourney) && journey.id) {
      fetchJourney(journey.id)
    }
  };
  const handleVehicleSelectClose = () => {
    setVehicleSelectModalOpen(false);
    if (isFunction(fetchJourney) && journey.id) {
      fetchJourney(journey.id)
    }
  };
  const handleAddEditTripSideBarClose = (status) => {
    setAddEditTripSideBarOpen(status)
    if (toggleRightSideBar) {
      toggleRightSideBar()
    }
    if (isFunction(fetchJourney) && journey.id) {
      fetchJourney(journey.id)
    }
  };
  const handleDriverSelectOpen = () => {
    setDriverNameModalOpen(true);
  };
  const handleDriverSelectConfirm = (response) => {
    if (response && response.id) {
    dispatchUpdateTrip(journey.id, { driverId: response.id }, (data) => {
         if (data && data.status && data.status.code && data.status.code === 200) {
           setDriverNameModalOpen(false);
              if (isFunction(fetchJourney) && journey.id) {
                fetchJourney(journey.id)
              }
         }else{
          setDriverNameModalOpen(false);
          fetchJourney(journey.id)
         }
       }, () => {

       })
     }
  }
  const handleVehicleSelectOpen = () => {
    setVehicleSelectModalOpen(true);
  };
  const handleVehicleSelectConfirm = (response) => {
    if (response && response.id) {
    dispatchUpdateTrip(journey.id, { vehicleId: response.id }, (data) => {
         if (data && data.status && data.status.code && data.status.code === 200) {
          setVehicleSelectModalOpen(false);
              if (isFunction(fetchJourney) && journey.id) {
                fetchJourney(journey.id)
              }
         }
       }, () => {

       })
     }
  }

  const classes = useStyles();

  useEffect(() => {
    dispatchChatView(false);
  }, []);

  const handleClose = () => {
    dispatchChatView(true);
    setDriverNameModalOpen(false);
    setVehicleSelectModalOpen(false);
    if (toggleRightSideBar) {
      toggleRightSideBar()
    }
  }
  const handleSave = () => {
    if (handleSubmit) {
      handleSubmit()
    }
    //dispatchChatView(true);
  }
  return (
    <>
    <Drawer
      variant="temporary"
      anchor="right"
      open={rightSideBarOpen}
      ModalProps={{
        keepMounted: false,
        className: classes.modal,
        BackdropProps: {
          className: classes.backdrop
        },
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        //onBackdropClick: handleClose
      }}
      classes={{
        paper: classes.transactionDetailsDrawer
      }}
    >
        <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} siderBarType={'truckBook'} 
        onClose={handleClose}
        onEdit={onEdit?(e)=>{onEdit(data,true)}:null}
        onDelete={onDelete?(e)=>{onDelete(data,true)}:null}
        >
          <div className={classes.titleDiv}>
            <div className={classes.divTitle}>
                  {sideBarTitle ? sideBarTitle : '--'}
            </div>
            {(!data || data && data.entityType != 'shopPayment') && <div className={classes.divSecTitle}>
                  {sideBarSecondaryTitle ? sideBarSecondaryTitle : ''}
            </div>}
          </div>
        </SideBarDialogTitle >
        <SideBarDialogContent dividers className={cStyle?classes.sideBarDialogContentV2:classes.sideBarDialogContentV1}>
          {/* {children} */}
          {vehicle && vehicle.vehicleId && <Box className={classes.box} display={'flex'} marginBottom={'8px'} padding={'16px'} backgroundColor={'#fff'} borderRadius={'8px'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
              <Box display={'flex'} alignItems={'center'}>
                <LocalShippingIcon className={classes.icon} />
                <Typography className={classes.text}> {vehicle && vehicle.vehicleNumber?vehicle.vehicleNumber:''}</Typography>
              </Box>
              <Box className={classes.edit} onClick={handleVehicleSelectOpen} display={'flex'} alignItems={'center'}>Edit</Box>
          </Box>}
          {driver && driver.driverId && <Box className={classes.box} display={'flex'} marginBottom={'24px'} padding={'16px'} backgroundColor={'#fff'} borderRadius={'8px'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
              <Box display={'flex'} alignItems={'center'}>
                <SteeringWheel className={classes.icon} />
                <Typography className={classes.text}>{driver && driver.driverName?driver.driverName:''}</Typography>
              </Box>
              <Box className={classes.edit} onClick={handleDriverSelectOpen} display={'flex'} alignItems={'center'}>Edit</Box>
          </Box>}
          {trips && trips.map((trip,index)=>{
            return <Box  className={classes.box} display={'flex'} marginBottom={'8px'} padding={'16px'} backgroundColor={'#fff'} borderRadius={'8px'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
                    <Box display={'flex'} flexDirection={'column'}>
                      <Typography className={classes.customer}>{trip && trip.customer && trip.customer.customerName?trip.customer.customerName:''}</Typography>
                      <Box marginTop={'2px'} display={'flex'} alignItems={'center'}>
                        <Typography className={classes.route}>{trip && trip.startLocation?trip.startLocation:''}-{trip && trip.destinationLocation?trip.destinationLocation:''}</Typography>
                        <FiberManualRecordIcon className={classes.sep}/>
                        <Typography className={classes.date}>{getDateInStringDDMMMYYYY(trip.startDate)}</Typography>
                      </Box>
                    </Box>
                    <Box display={'flex'} alignItems={'center'}>
                      <Box onClick={()=>{setSelectedTrip(trip);setAddEditTripSideBarOpen(true)}} className={classes.edit} display={'flex'} alignItems={'center'}>Edit</Box>
                      <Box onClick={()=>{setSelectedTrip(trip);setDeleteTripOpen(true)}} className={classes.delete} marginLeft={'8px'} display={'flex'} alignItems={'center'}>Delete</Box>
                    </Box>
                </Box>
          })}
          
        </SideBarDialogContent>
        <SideBarDialogActions className={classes.sideBarActions} >
                <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
                  Close
                </Button>
        </SideBarDialogActions>
    </Drawer >
    {driverNameModalOpen && <JourneyDriverSelect selectedDriver={driver} journey={journey} updateJourney={updateJourney} onOpen={driverNameModalOpen} onClose={handleDriverSelectClose} onConfirm={handleDriverSelectConfirm} />}
    {vehicleSelectModalOpen && <JourneyVehicleSelect selectedVehicle={vehicle} journey={journey} updateJourney={updateJourney} onOpen={vehicleSelectModalOpen} onClose={handleVehicleSelectClose} onConfirm={handleVehicleSelectConfirm} />}
    {addEditTripSideBarOpen && <AddEditLoadSideBar journey={journey} selectedTrip={selectedTrip} updateJourney={updateJourney} sideBarTitle="Edit Load" sideBarOpen={addEditTripSideBarOpen} sideBarClose={handleAddEditTripSideBarClose} tripId={selectedTrip&&selectedTrip.id?selectedTrip.id:null} />}
    {deleteTripOpen && <DeleteTripJourney deleteOpen={deleteTripOpen} loadId={selectedTrip.id} onDeleteSucees={onTripDeleteSucees} onDeleteNo={onTripDeleteNo} />}
    </>
  );
};

EditLoadDetailsSideBar.propTypes = {
  rightSideBarOpen: PropTypes.bool,
  toggleRightSideBar: PropTypes.func
};
const EditLoadDetailsSideBarWithRouter = withRouter(EditLoadDetailsSideBar);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchChatView: (value) => dispatch(updateChatView(value)),
  dispatchToggleChatSupport: (value) => dispatch(toggleChatSupport(value)),
  dispatchBiltyContinueClick: (value) => dispatch(biltyContinueClick(value)),
  dispatchUpdateTrip: (tripId, trip, onSuccess, onError) => {
    dispatch(updateJourney(tripId, trip, onSuccess, onError));
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditLoadDetailsSideBarWithRouter);
